import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { usePARoutesConditions } from '../../../../PaymentAgent/PaymentAgentRoutes'
import { MoneyNoteIcon } from '../../../../icons/MoneyNoteIcon'
import { TickmillProductType } from '../../../../model/TickmillProductType'
import { MenuSection } from '../useMenuSections'

export const usePAMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { isPAVisible } = usePARoutesConditions()

  return useMemo(
    () => ({
      id: 'payment-agent',
      label: t('Tabs.Payment Agent'),
      icon: MoneyNoteIcon,
      condition: isPAVisible,
      products: [TickmillProductType.CFD],
      children: [
        {
          id: 'pa-wallets',
          label: t('Tabs.Wallets'),
          path: '/dashboard/payment-agent/wallets',
        },
        {
          id: 'pa-transaction-history',
          label: t('Tabs.Transaction History'),
          path: '/dashboard/payment-agent/transaction-history',
        },
        {
          id: 'pa-profile-info',
          label: t('Tabs.Profile Info'),
          path: '/dashboard/payment-agent/profile-info',
        },
      ],
    }),
    [t, isPAVisible]
  )
}
